export const ADMIN_DASHBOARD_HEADER = 6;
//# sourceMappingURL=dashboard.js.map